import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { Posting } from 'app/library/posting/models/posting.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { GeneralAnalyticsService } from 'app/services/general-analytics.service';

@Component({
    selector: 'app-related-post-details',
    templateUrl: './related-post-details.component.html',
    styleUrls: ['./related-post-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class RelatedPostDetailsComponent extends UnsubscribeOnDestroy implements OnInit {
    relatedPostings: Posting[];
    index: number; //The index of the current item in the iterable.
    isFirst: boolean; //True when the item is the first item in the iterable.
    isLast: boolean; //True when the item is the last item in the iterable.

    constructor(
        public dialogRef: MatDialogRef<RelatedPostDetailsComponent>,
        public tenantDataService: TenantDataService,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        private _router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.sendPostingViewEvent('posting_clicked');
    }

    nextPost() {
        this.index++;

        // checks if currently selected post is first, if that's true, we hide prev arrow
        const currentItem = this.relatedPostings[this.index];
        const lastItem = this.relatedPostings[this.relatedPostings.length - 1];
        this.isFirst = false;
        if (lastItem.id === currentItem.id) {
            this.isLast = true;
        } else {
            this.isLast = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    prevPost() {
        this.index--;

        // checks if currently selected post is last, if that's true, we hide next arrow
        const currentItem = this.relatedPostings[this.index];
        const firstItem = this.relatedPostings[0];
        this.isLast = false;
        if (firstItem.id === currentItem.id) {
            this.isFirst = true;
        } else {
            this.isFirst = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    openPostingUrl() {
        const posting = this.relatedPostings[this.index];
        if (posting.kind === 'article') {
            this.dialogRef.close();
            this._router.navigate([`grow/articles/${posting.article.uniqueId}/${posting.article.id}`]);
        } else {
            const currentPostUrl = posting.url;
            window.open(currentPostUrl, '_blank');
            this.sendPostingViewEvent('posting_link_followed');
        }
    }

    async sendPostingViewEvent(eventName: string) {
        if (this._router.url === '/grow') {
            const currentPostId = this.relatedPostings[this.index].id;
            const postingResource = this.relatedPostings.find((posting) => posting.id === currentPostId);
            /* this._locationBasedAnalyticsService.createPostingEvent(
                eventName,
                postingResource.id,
                postingResource.posting.postingType.id,
                postingResource.translation.title,
                postingResource.audience,
                this.featuredWidget.id,
                this.featuredWidget.name
            ); */
        }
    }
}
